import type { OfficialHomeLanguage } from '../../types';

export interface IPWorkflowStep {
  id: string;
  title: string;
  description: string;
}

// 使用本需求提供的中英文原文，沿用官网营销内容模式，不写入 Smartcat 语言包。
export const IP_WORKFLOW_CONTENT: Record<OfficialHomeLanguage, IPWorkflowStep[]> = {
  'zh-Hans': [
    { id: 'create', title: '轻松创建角色IP', description: '从零创造一个角色IP，或基于已有素材整理为结构化IP档案。' },
    { id: 'script', title: '专业剧本工作台', description: '剧本Agent帮你完成设定与生成，边聊边改，自动同步到画布。' },
    { id: 'create-with-ip', title: 'IP垂类多元创作', description: '选定角色IP后，AI短剧、日常短视频、表情包等多个场景任意选择，从设定到成片一气呵成。' },
    { id: 'repeat', title: '资产沉淀持续创作', description: '每个角色IP拥有独立的展示页，所有产出自动归档，随时调用、持续迭代，创作效率随积累持续提升。' },
  ],
  en: [
    { id: 'create', title: 'Create Your IP', description: 'Start from zero, or turn what you already have into a full IP profile.' },
    { id: 'script', title: 'Script Workbench', description: 'A script agent guides setup and generation. Refine through conversation — everything syncs to the canvas.' },
    { id: 'create-with-ip', title: 'Create with Your IP', description: 'Choose a character, then pick your format — short drama, video, sticker, or viral remake. AI handles it end-to-end.' },
    { id: 'repeat', title: 'Repeat with Your IP', description: 'Every character has its own page. Everything you make is saved, reusable, and gets better over time.' },
  ],
};

// 四个流程步骤分别使用对应的正式演示视频，顺序与上方步骤内容保持一致。
export const IP_WORKFLOW_VIDEOS = [
  'https://titan-img.meitudata.com/roboneo/image/overseahome/create_your_ip.mp4',
  'https://titan-img.meitudata.com/roboneo/image/overseahome/script_workbench.mp4',
  'https://titan-img.meitudata.com/roboneo/image/overseahome/create_with_your_ip.mp4',
  'https://titan-img.meitudata.com/roboneo/image/overseahome/repeat_with_your_ip_new.mp4',
];
